const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const {ErrorBoundary} = require("react-error-boundary");

const createReactClass = require("create-react-class");

const ErrorUtil = require("../../../shared/ErrorUtil");
const GlobalFlags = require("../util/GlobalFlags");
const Analytics = require("../util/Analytics");
const BrowserUtil = require("../util/BrowserUtil");
const {FLAGS} = GlobalFlags;
const AT = require("../vault/ActionTypes");
const OpsPage = require("../vault/OpsPage");
const IplBlockedUtil = require("../util/IplBlockedUtil");
const DevNavigation = require("../view/DevNavigation/index");
const IplBlockedView = require("./IplBlockedView");

const ErrorMessage = require("../view/ErrorMessage");
const {DevErrorIndicator} = require("../view/DevErrorIndicator");
const ImitatorIndicator = require("../view/ImitatorIndicator");
const PrivacyChangeAlert = require("../view/PrivacyChangeAlert");
const MainTrainerContainer = require("./MainTrainerContainer");
const MainOfficeContainer = require("./MainOfficeContainer");
const VaultContext = require("./VaultContext").default;
const RouterContext = require("./RouterContext").default;

const styles = require("./styles/MainContainer.css");
const {
	setupDevTestingShortcut,
	teardownDevTestingShortcut,
} = require("../util/setupDevTestingShortcut");

// This global is set up for the use of src/office/InitRenderSwitch.jsx so that
// components can switch their children after the first render, used to switch out
// components that are rendered slightly differently in server side rendering.
global.hasFirstRenderOccurred = false;

module.exports = createReactClass({
	displayName: "MainContainer",

	propTypes: {
		containerEl: PT.instanceOf(global.HTMLElement),
		vault: PT.object.isRequired,
		router: PT.object.isRequired,
	},

	getInitialState: function() {
		const vaultState = this.props.vault.getState();
		return this.computeViewState(vaultState);
	},

	componentDidMount: function() {
		global.hasFirstRenderOccurred = true;
		this.props.vault.on("update", this.onVaultUpdate);
		// Set initial window aspect ratio for comparison later
		this.onResize();

		// TODO: better location for bad browser check
		const supported = BrowserUtil.isSupportedBrowser();
		if (!supported) {
			this.props.vault.dispatch({type: AT.SET_BAD_BROWSER});
		} else if (!BrowserUtil.hasCookiesEnabled()) {
			this.props.vault.dispatch({type: AT.SET_NO_COOKIES});
		}
		if (global.window) {
			global.window.addEventListener("resize", this.onResize);
			setupDevTestingShortcut();
		}
	},

	componentWillUnmount: function() {
		this.props.vault.off("update", this.onVaultUpdate);
		if (global.window) {
			global.window.removeEventListener("resize", this.onResize);
			teardownDevTestingShortcut();
		}
	},

	onVaultUpdate: function(vaultState) {
		const newState = this.computeViewState(vaultState);
		const oldState = _.pick(this.state, _.keys(newState));
		if (!_.isEqual(newState, oldState)) {
			this.setState(newState);
		}
	},

	onIplStaffBypass: function() {
		IplBlockedUtil.setStaffBypass();
		this.onVaultUpdate(this.props.vault.getState());
	},

	onResize: function() {
		if (!global.document) return;
		if (!document.body) return;

		const newWidth = document.body.clientWidth || 1;
		const newHeight = document.body.clientHeight || 1;
		const newRatio = newHeight / newWidth;

		if (
			// landscape to portrait
			(this.aspectRatio && this.aspectRatio < 1 && newRatio >= 1) ||
			// portrait to landscape
			(this.aspectRatio && this.aspectRatio > 1 && newRatio <= 1)
		) {
			this.props.vault.dispatch({type: AT.DEVICE_ROTATE});
		}
		this.aspectRatio = newRatio;
	},

	computeViewState: function(vaultState) {
		if (!vaultState || !vaultState.page) {
			return {ready: false};
		}
		const page = vaultState.page;
		const user = vaultState.user;
		const isOfficePage = OpsPage.isOfficePage(page);
		const isHotjarPage = OpsPage.isHotjarPage(page);
		const isPostLoginPage = OpsPage.isPostLoginPage(page);
		const isIplBlocked = OpsPage.isIplUserAppBlocked(user, page);
		return {
			ready: true,
			connected: vaultState.connected,
			isOfficePage,
			isHotjarPage,
			isPostLoginPage,
			isIplBlocked,
			screenWarning: vaultState.screenWarning,
		};
	},

	render: function() {
		if (!this.state.ready) {
			return <div className={styles.main} />;
		}

		// styles.main must not be positioned in CSS. See MainTrainerContainer.jsx
		// for details.
		let topClasses = styles.main;
		if (!this.state.connected) {
			//TODO: is there a way to make this not global? Used in ErrorMessage.
			topClasses += " ba-disconnected";
		}

		const renderSubcontainer = () => {
			if (this.state.isIplBlocked) {
				return (
					<IplBlockedView
						user={this.props.vault.getState().user}
						onStaffBypass={this.onIplStaffBypass}
					/>
				);
			} else {
				let SubcontainerComponent = this.state.isOfficePage
					? MainOfficeContainer
					: MainTrainerContainer;
				if (this.state.screenWarning === "demo") {
					// If they go to demo on a phone, we want to take them to somewhere with office top bar
					SubcontainerComponent = MainOfficeContainer;
				}
				// Post sign-in should be immediately redirected after
				// loadguard, so we can just show nothing (null) for it.
				if (!this.state.isPostLoginPage) {
					return <SubcontainerComponent containerEl={this.props.containerEl} />;
				}
			}
		};

		const hideAppChrome = this.state.isIplBlocked;

		let devNav = null;
		if (this.state.reactCrashed || hideAppChrome) {
			// Avoid all the branches below.
		} else if (FLAGS.showDebugPanels && !this.state.isPostLoginPage) {
			this.backdoorDebugPanelNotice = false;
			devNav = (
				<DevNavigation
					onHideAll={this.onHideDev}
					onFlagChange={() => this.forceUpdate()}
				/>
			);
		} else if (
			!this.backdoorDebugPanelNotice &&
			process.env.NODE_ENV !== "production"
		) {
			this.backdoorDebugPanelNotice = true;
			global.SHOW_BA_DEBUG_PANELS = () => {
				global.SHOW_BA_DEBUG_PANELS = null;
				GlobalFlags.setFlagAndSave("showDebugPanels", true);
				this.forceUpdate();
			};
			// eslint-disable-next-line no-console
			console.log(
				"Call the global function SHOW_BA_DEBUG_PANELS " +
					"to restore the panels in the corners."
			);
		}

		let devErrorIndicator = null;
		if (FLAGS.showErrorsInConsole && !hideAppChrome) {
			devErrorIndicator = <DevErrorIndicator />;
		}

		const hotjarSuppressionAttributes = this.state.isHotjarPage
			? {}
			: Analytics.getHotjarSuppressionAttributes();
		return (
			<VaultContext.Provider value={this.props.vault}>
				<RouterContext.Provider value={this.props.router}>
					<div className={topClasses} {...hotjarSuppressionAttributes}>
						<ErrorBoundary
							onError={(error, info) => {
								ErrorUtil.log("E_REACT_CRASH", error, {
									componentStack: info.componentStack,
								});
							}}
							fallback={<ErrorMessage />}
						>
							{renderSubcontainer()}
						</ErrorBoundary>
						{devNav}
						{devErrorIndicator}
						{!hideAppChrome && <ImitatorIndicator />}
						{!hideAppChrome && <PrivacyChangeAlert />}
					</div>
				</RouterContext.Provider>
			</VaultContext.Provider>
		);
	},
});
